import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import styled from 'styled-components'
import Broker from './Broker'
import { Mobile } from '../../../media'
import { connect } from "react-redux";
import employeeService from '../../../services/Employee.service'

const Wrapper = styled.div`
  background-color: white;
  width: 50%;
  height: auto;
  margin: 0 auto;
  padding-top: 40px;
  padding-left: 160px;
  padding-bottom: 21px;

  // Mobile version.
  @media (max-width: 768px) {
    width: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-top: 34px;
    padding-left: 16px;
    padding-right: 16px;
  }

  > h2 {
    font-family: Lato-Light;
    font-size: 24px;
    font-weight: normal;

    color: #2B2B2B;
    text-align: left;
    line-height: 28px;
    margin-top: 0;
    margin-bottom: 26px;
  }

  .ratings-text {
    width: 576px;
    border: 1px solid #dddddd
    font-family: Lato-Regular;
    font-size: 14px;
    color: #2B2B2B;
    line-height: 22px;
    padding: 10px 16px;
  }

  > div:last-child {
    clear: both;
  }
`

class Brokers extends Component {

  render() {
    const { t, broker_info, employee } = this.props
    const brokerInfo = employeeService.reorderBrokerInfo(broker_info, employee)

    return (
        <Wrapper id="brokers">
            <Mobile>
                <h2>{t("AvailableBrokers.AvailableBrokers")}</h2>
            </Mobile>
            <div style={{display: "flex", alignItems: "flex-start"}}>
              {brokerInfo.map(({broker, broker_comparisons}, index) => (
                <Broker key={index} index={index} broker={broker} broker_comparisons={broker_comparisons}>
                  <img width="208" src={`/image/broker-logo-${broker.code}.svg`} alt={`Broker ${broker.name} Logo`} />
                </Broker>
              ))}
            </div>
            { employeeService.isAPSEmployee(employee) && (employeeService.isBrokerChoiceAll(employee) || employeeService.isBrokerChoiceDisable(employee)) && employeeService.isUserCode5Email(employee) &&
              <div style={{display: "flex", alignItems: "flex-start"}}>
                <p className="ratings-text" dangerouslySetInnerHTML={{ __html: t("AvailableBrokers.BrokerRatingsText") }}>
                </p>
              </div>
            }
            <div />
        </Wrapper>
    )
  }
}

const mapState = state => ({
    broker_info: state.static_content.broker_info,
    brokers: state.configuration.brokers,
    employee: state.employee
 });

export default connect(mapState, null)(withTranslation('translations')(Brokers))
